module.exports = __webpack_public_path__ + "img/working.31cdfb1e.gif";